import React, { useState, useEffect, useRef } from 'react';
import { Divider } from 'primereact/divider';
import './VerifyPhone.css';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';
import { AuthApiService } from '../../../services/AuthApiService';
import { Toast } from 'primereact/toast';
const VerifyPhone = () => {
  const history = useHistory();
  const [value1, setValue1] = useState('');
  const [countDown, setCountDown] = useState(0);
  const [runTimer, setRunTimer] = useState(true);
  const [requestId, setRequestId] = useState();
  const [deviceId, setDeviceId] = useState();
  const [userName, setUserName] = useState();
  const [status, setStatus] = useState('');
  const [message, setMessage] = useState('');
  const [phone, setPhone] = useState('')
  const toast = useRef(null);
  const _apiService = new AuthApiService();

  useEffect(() => {
    let timerId;
    if (runTimer) {
      setCountDown(60 * 10);
      timerId = setInterval(() => {
        setCountDown((countDown) => countDown - 1);
      }, 1000);
    } else {
      clearInterval(timerId);
    }
    requestSMSPasscode();
    setPhone(history.location.state.mobilePhone)

    return () => clearInterval(timerId);
  }, [runTimer]);

  useEffect(() => {
    if (countDown < 0 && runTimer) {
      console.log('expired');
      setRunTimer(false);
      setCountDown(0);
    }
  }, [countDown, runTimer]);

  // useEffect(() => {
  //   setRequestId(history.location.state.requestId);
  //   setDeviceId(history.location.state.deviceId);
  //   setUserName(history.location.state.userRefId);
  // }, [])

  useEffect(() => {
    if (status === 200) {
      history.push({ pathname: '/auth/phone-success', state: { mobilePhone: phone }});
    }
  }, [status !== 200]);

  const handleValidatePasscode = () => {
    if (value1 !== '') {
      validateSMSPasscode(value1);
    } else {
      setMessage('Required');
    }
  };

  const requestSMSPasscode = async () => {
    const enrollData = {
      schemas: ['urn:ietf:params:scim:schemas:oracle:idcs:AuthenticationFactorInitiator'],
      deviceId: history.location.state.deviceId,
      requestId: history.location.state.requestId,
      userName: history.location.state.userRefId,
      authFactor: 'SMS',
    };

    const reqPass = await _apiService.postRequestPassMobile(enrollData);
    if (!reqPass || reqPass.error || reqPass.status === '401') {
      if (reqPass.status === '401') {
        setMessage(reqPass.detail);
        // toast.current.show({ severity: 'error', summary: reqPass.detail, detail: 'Message Content', life: 3000 });
      } else {
        setMessage(reqPass.error);
        // toast.current.show({ severity: 'error', summary: reqPass.error, detail: 'Message Content', life: 3000 });
      }

      return;
    } else {
      setDeviceId(reqPass.deviceId);
      setRequestId(reqPass.requestId);
      setCountDown(60 * 10)
      // toast.current.show({ severity: 'success', summary: 'Request Send!', detail: 'Message Content', life: 3000 });
    }
  };

  const validateSMSPasscode = async (passCode) => {
    const data = {
      schemas: ['urn:ietf:params:scim:schemas:oracle:idcs:AuthenticationFactorValidator'],
      deviceId: deviceId,
      requestId: requestId,
      otpCode: passCode,
      authFactor: 'SMS',
      scenario: 'ENROLLMENT',
    };
    const res = await _apiService.postValidatePassMobile(data);

    console.log(res);
    if (!res || res.error || res.status === '401') {
      if (res.status === '401') {
        setStatus(res.detail);
        setMessage(res.detail);
        // toast.current.show({ severity: 'error', summary: res.detail, detail: 'Message Content', life: 3000 });
      } else {
        setStatus(res.error);
        setMessage(res.error);
        // toast.current.show({ severity: 'error', summary: res.error, detail: 'Message Content', life: 3000 });
      }

      return;
    } else {
      setStatus(200);
    }
  };

  const seconds = String(countDown % 60).padStart(2, 0);
  const minutes = String(Math.floor(countDown / 60)).padStart(2, 0);
  return (
    <div className="rightside-container">
      <div className="rightside-body px-6">
        <div className="flex flex-column align-items-center">
          <h3>Two-step Verification</h3>
          <span>
            Two-step verification adds an additional layer of security by using a second device to verify your identity.
          </span>
          <Divider className="py-3" />
        </div>
        <div className="pt-2 lg:w-5 md:w-5 mx-auto">
          <h3 className="m-0">Let's verify your phone.</h3>
          <p className="mt-5">
            <b>We sent the verification code to {history.location.state.mobilePhone}</b>
          </p>
          <p>Please allow up to 2 minutes for the verification code to arrive.</p>
          <div className="mt-5 pt-5">
            <InputMask
              placeholder="Enter Code"
              type='tel'
              className={message ? 'p-invalid block w-full' : 'w-full'}
              value={value1}
              mask="999999"
              slotChar=''
              onChange={(e) => {
                setValue1(e.value);
                setMessage('');
              }}
            />
            <Toast ref={toast} />
            <small className="p-error block">{message}</small>
            <Button
              onClick={() => handleValidatePasscode()}
              label="Confirm"
              className="p-button-info w-full mt-3 py-3"
            />
          </div>
          <div className="flex justify-content-between align-items-center">
            <div>
              <p>
                Code expires in:{' '}
                <span style={{ color: 'red' }}>
                  {minutes}:{seconds}
                </span>
              </p>
            </div>
            <div>
              <b className="text-primary cursor-pointer" onClick={() => requestSMSPasscode()}>
                Resend Code
              </b>
            </div>
          </div>
          <b onClick={() => history.goBack()} className="text-primary cursor-pointer">
            Cancel
          </b>
        </div>
      </div>
    </div>
  );
};

export default VerifyPhone;
